<div class="export-download-modal-backdrop" *ngIf="show" (click)="onBackdropClick($event)">
  <div class="export-download-modal modal-content" (click)="$event.stopPropagation()">
    <ng-container *ngIf="step === 'choose'">
      <ng-container *ngIf="simpleDisclaimerMode; else defaultChooseStep">
        <h2>{{ warningTitle }}</h2>
        <p class="warning-text">
          <strong>{{ warningPrefix || 'Recomendações de LGPD:' }}</strong>
          {{ warningMessage }}
        </p>
        <div class="actions actions-center">
          <button class="cancel-btn" (click)="close.emit()">Cancelar</button>
          <button class="option-btn primary-action-btn" (click)="chooseDownload()">Download</button>
        </div>
      </ng-container>

      <ng-template #defaultChooseStep>
        <h2>Exportar relatório</h2>
        <div class="options">
          <button class="option-btn" (click)="chooseDownload()">
            <span class="icon" style="font-size:20px;margin-right:8px;vertical-align:middle;">🗂️</span>
            Download Local
          </button>
          <button class="option-btn" (click)="chooseEmail()">
            <span class="icon" style="font-size:20px;margin-right:8px;vertical-align:middle;">📧</span>
            Enviar por E-mail
          </button>
        </div>
        <div class="actions">
            <button class="cancel-btn" (click)="close.emit()">Cancelar</button>
        </div>
      </ng-template>
    </ng-container>



    <ng-container *ngIf="step === 'email-warning'">
      <div class="email-warning-modal" style="background: #fffbe6; border: 2px solid #f5c518; border-radius: 8px; padding: 28px 20px; text-align: center; box-shadow: 0 2px 8px rgba(0,0,0,0.07); max-width: 700px; width: 100%; margin: 0 auto;">
        <h2 style="color: #b38600; font-size: 22px; margin-bottom: 18px;">Atenção obrigatória</h2>
        <p style="font-size: 17px; color: #333; margin-bottom: 18px;">
          O download do relatório <strong style="word-break: break-all; display: inline-block; max-width: 100%;">{{fileName}}</strong> será feito agora.<br>
          Você deve anexar este arquivo ao e-mail que será enviado na próxima etapa.
        </p>
        <div class="actions" style="margin-top: 18px; display: flex; justify-content: center;">
          <button class="option-btn" style="background: #f5c518; color: #222; min-width: 120px; font-weight: bold;" (click)="confirmEmailWarning()">OK</button>
        </div>
      </div>
    </ng-container>

    <ng-container *ngIf="step === 'email'">
      <h2>Enviar relatório por e-mail</h2>
      <div class="options email-options" style="display: flex; flex-direction: column; gap: 12px; align-items: center;">
        <button class="option-btn email-app-btn" (click)="sendEmail('outlookWeb')">
          <span class="icon" style="font-size:20px;margin-right:8px;vertical-align:middle;">🌐</span>
          Outlook Web
        </button>
        <button class="option-btn email-app-btn" (click)="sendEmail('mailto')">
          <span class="icon" style="font-size:20px;margin-right:8px;vertical-align:middle;">📧</span>
          Email Padrão do Sistema
        </button>
      </div>
      <div class="actions" style="margin-top: 16px;">
          <button class="cancel-btn" (click)="close.emit()">Cancelar</button>
      </div>
    </ng-container>
